import React from 'react'
import { BtAlert } from '@linqpal/components/src/ui'
import { Text, Divider } from 'react-native-paper'
import { View, Image } from 'react-native'
import { theme } from '@linqpal/common-frontend'
import image from '../../../assets/images/whatIsBTC.svg'
import { useTranslation } from 'react-i18next'

interface WhatIsBTModalProps {
  modal: boolean
  setModal: (arg: boolean) => void
  setBtcredit: (arg: boolean) => void
  isInvoiceEligible: boolean
}

const { commonColors } = theme

export const WhatIsBTModal: React.FC<WhatIsBTModalProps> = ({
  modal,
  setModal,
  setBtcredit,
  isInvoiceEligible,
}) => {
  const { t } = useTranslation('global')
  return (
    <BtAlert
      visible={modal}
      height={730}
      title={t('BTModal.alertTitle')}
      onClose={() => {
        setModal(false)
      }}
      buttons={[
        {
          label: t('BTModal.request_credit'),
          disabled: !isInvoiceEligible,
          onPress: () => {
            setModal(false)
            setBtcredit(true)
          },
          style: { width: '100%', marginTop: 14 },
        },
      ]}
    >
      <Divider style={{ marginBottom: 34 }} />
      <View style={{ width: '100%' }}>
        <Image
          style={{
            width: 252,
            height: 212,
            alignSelf: 'center',
            marginBottom: 74,
          }}
          source={{ uri: image }}
        />
      </View>
      <View style={{ marginHorizontal: 20 }}>
        <Text
          style={{
            color: commonColors.textLight,
            fontWeight: '400',
            textAlign: 'center',
            fontSize: 16,
            maxWidth: 550,
          }}
        >
          {t('BTModal.title')}
        </Text>
        <Text
          style={{
            fontSize: 12,
            marginTop: 37,
            alignSelf: 'center',
            fontWeight: '500',
            color: commonColors.textLight,
            lineHeight: 20,
          }}
        >
          {t('BTModal.subtitle')}
        </Text>
      </View>
    </BtAlert>
  )
}
